module.exports = __webpack_public_path__ + "img/banner-3.854e249f.jpg";